import React, { useContext, useEffect, useState } from 'react'
import Card from '../../../Base/Components/Card/Card'
import TimeLine from '../../../Base/Components/TimeLine/TimeLine'
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext'
import { getMaquinasTintoreria, getPartidasCargadasMaquina, getUltimosParosMaquinas } from '../../../API/Produccion/Dyeing/DyeingRequests'
import StyleCategoryIcon from '../../../Base/Components/Icon/StyleCategoryIcon'
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid'
import MetasSemanalesPorCategoria from '../../Ventas/ResumenVentas/MetasSemanalesPorCategoria'
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek'
import { Button } from 'primereact/button'
import { useNavigate } from 'react-router-dom';
import MetasSemanalesTintoreria from '../../Ventas/ResumenVentas/MetasSemanalesTintoreria'

const DyeingMachineWorkflow = () => {

    const { config, setTimeLineDyeMachines } = useContext(ConfigContext);

    const [dates, setDates] = useState([new Date('01/01/2024'), new Date('12/31/2025')]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [paros, setParos] = useState([]);
    const [fecha, setFecha] = useState(new Date());
    const [inicio, setInicio] = useState(false);
    const navigate = useNavigate();
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    })

    // console.log(config);

    const getInfo = async () => {
        setLoading(true);
        // Fetch data and update state
        const m = await getPartidasCargadasMaquina();
        // console.log(m);
        setData(m);
        setLoading(false);
    }

    const getParos = async () => {
        setLoading(true);
        const p = await getUltimosParosMaquinas();

        let parosActivos = p.filter(e => e.EndTime === null)
        let parosFinalizados = p.filter(e => e.EndTime !== null);

        let finalizados = parosFinalizados?.sort((a, b) => {
            const dateCompare = b?.Date?.localeCompare(a?.Date);
            if (dateCompare !== 0) return dateCompare;
            return b?.EndTime?.localeCompare(a?.EndTime);
        })?.slice(0, 20);


        setParos([...parosActivos, ...finalizados]);
        setLoading(false);
        setInicio(true)
        return p;
    }

    const getDetails = async (IdDyeMachine, setDetail) => {
        // Fetch details for the given IdDyeGroup
        let d = data.find(d => d.IdDyeMachine === IdDyeMachine)?.details
        // console.log(d, data, IdDyeMachine);
        setData(d);

        setDetail(d || []);
        // getPartidasCargadasMaquina(IdDyeGroup)
        //     .then((details) => {
        //         setDetails(details);
        //     })
        //     .catch((error) => {
        //         console.error("Error fetching details:", error);
        //     });
    }

    const columns = [
        {
            field: 'Machine',
            header: 'Machine',
            headerEn: '',
            className: 'small',
        },
        {
            field: 'NumeroLote',
            header: 'NumeroLote',
            headerEn: '',
            className: 'small',
            Sumary: 'count'
        },
        {
            field: 'ColourDescript',
            header: 'Colour',
            headerEn: '',
            className: '',
        },
        {
            field: 'Weight',
            header: 'Weight',
            headerEn: '',
            className: 'small',
            Format: 'Currency',
            // Sumary: 'sum',
        },


        // {
        //     field: 'ShortName',
        //     header: 'ShortName',
        //     headerEn: '',
        //     className: '',
        // },
        {
            field: 'Name',
            header: 'Name',
            headerEn: '',
            className: 'XXlarge',
            // flex: 1
        },
        {
            field: 'Date',
            header: 'Date',
            headerEn: 'Date',
            className: 'small',
            Format: 'Date',
        },
        {
            field: 'StartDate',
            header: 'StartDate',
            headerEn: '',
            className: 'small'
            // Format: 'DateTime',
            // className: 'large',
        },
        {
            field: 'EndTime',
            header: 'EndTime',
            headerEn: '',
            className: 'small',
            // Format: 'DateTime',
            // width: 200,
            // Sort: 'asc',
        },
        {
            field: 'Duration',
            header: 'Tiempo Paro',
            headerEn: '',
            className: '',
            Format: 'Center'
        },
        {
            field: 'NombreOperador',
            header: 'Operador',
            headerEn: '',
            className: 'Xlarge',
        },

        {
            field: 'Hours',
            header: 'Hours',
            headerEn: '',
            className: 'XXsmall',
        },
        {
            field: 'Minutes',
            header: 'Minutes',
            headerEn: '',
            className: 'XXsmall',
        },
    ]
    const table = {
        Data: paros,
        Columns: columns,
        loading: loading,
        hideFilter: true,
        rowClassRules: {
            'ag-rows-red': (params) => {
                return params.data.EndTime === null;
            },
        },
    }

    const titleItem = (Item) => {
        // return item.Title
        return (
            <div className='col-12 d-flex ' style={{ justifyContent: 'space-between' }}>
                <div className='col-1' style={{ color: '#FFF' }} >
                    <StyleCategoryIcon
                        StyleCategory={Item?.StyleCategory}
                        color={'#FFFFFF'}
                    />
                    {/* <FontAwesomeIcon icon="fa-solid fa-circle-user" />
                // < */}
                    {/* <FontAwesomeIcon icon="fa-brands fa-cotton-bureau" /> */}
                    {/* {Item?.KgsQty && <div className='nowrap' style={{ color: '#FFFFFFCC' }}>{(Item?.StyleCategory === 'Cotton' ? 'C' : 'S')}</div>} */}
                </div>
                <div
                    // onDoubleClick={e => {
                    //     setSalesOrderEdit(Item);
                    //     setShowDialogSalesOrder(true);
                    //     e.stopPropagation();
                    // }}
                    className='nowrap col-9'>
                    {Item.Title}
                </div>
                <div className='col-1'>
                    {Item?.ContentNumber && <div className='nowrap content'>( {Item.ContentNumber} )</div>}
                </div>
            </div>
        )
    }

    useEffect(() => {
        let configTimeLine = {
            // dayWidth: config.timeLineDyeMachines.dayWidth ? config.timeLineDyeMachines.dayWidth : 10,
            // showDays: config.timeLineDyeMachines.showDays ? config.timeLineDyeMachines.showDays : false,
            // showWeeks: config.timeLineDyeMachines.showWeeks ? config.timeLineDyeMachines.showWeeks : true,
            // showMonths: config.timeLineDyeMachines.showMonths ? config.timeLineDyeMachines.showMonths : true,
            // dividerPosition: config.timeLineDyeMachines.dividerPosition ? config.timeLineDyeMachines.dividerPosition : 300,
            // sortBy: config.timeLineDyeMachines.sortBy ? config.timeLineDyeMachines.sortBy : 'endTime',
            // sortDirection: config.timeLineDyeMachines.sortDirection ? config.timeLineDyeMachines.sortDirection : 'desc'
            ...config?.timeLineDyeMachines,
            // showOptions: config.timeLineDyeMachines.showOptions ? config.timeLineDyeMachines.showOptions : false,
            IdItem: config?.timeLineDyeMachines?.IdItem ? config.timeLineDyeMachines?.IdItem : "IdDyeMachine"
        }
        // guardarTimeLineConfig();
        // setTimeLineDyeMachines(configTimeLine);
        getInfo();
    }, [])

    useEffect(() => {
        getParos();
        const handleResize = () => {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);

        // Cleanup function to remove the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])
    useEffect(() => {
        if (inicio) {
            const interval = setInterval(() => {

                getParos();
            }, 60000);
            // setInicio(false)
            return () => {
                getParos();
                clearInterval(interval);
            };
        }
    }, [inicio])

    return (
        <div>

            <Card
                titulo={<div>
                    <h5 className='m-0'>Flujo de Trabajo - Maquinas de Teñido</h5>
                </div>}
                contenido={<div  >
                    <div className='d-flex gap mt-2' >
                        <Button
                            tooltip='Home'
                            icon='pi pi-arrow-left'
                            onClick={() => {
                                navigate(`${process.env.REACT_APP_ENV}/Home`);
                            }}
                        />
                        <CalendarWeek date={fecha} setDate={e => setFecha(e)}

                            view="month" dateFormat="mm/yy"
                        />
                    </div>
                    <div className='tinto'>
                        {/* <div style={{ width: '60%' }}> */}
                            <MetasSemanalesTintoreria kpiGerencia={true} date={fecha} getDatos={getInfo} setShowMetasProduccion={() => { }} altura={false} />
                        {/* </div> */}
                        
                            <MetasSemanalesPorCategoria kpiGerencia={false} date={fecha} getDatos={getInfo} altura={false} visible={false} />
                        

                    </div>

                    <div className='pt-2' style={{ height: '32vh' }}>
                        <AgGrid table={table} />
                    </div>


                </div>}
            />
        </div>
    )
}

export default DyeingMachineWorkflow